// ─────────────────────────────────────────────────────────────────────────────
// Negrito, itálico e sublinhado no texto do ticket.
//
// O MySuite renderiza `<b>`, `<i>` e `<u>` na interação — é assim que se
// destaca a mensagem de erro exata ou o passo que o cliente precisa seguir.
//
// A regra que importa: os botões são ALTERNADORES. Se a seleção já está dentro
// da tag (ou exatamente envolvida por ela), a tag sai. Nunca aninha: um
// `<b><b>texto</b></b>` quebra a renderização do MySuite, e o operador só
// descobre quando o cliente responde perguntando o que era aquilo.
//
// Módulo puro — testado em scripts/teste-formatacao.mjs.
// ─────────────────────────────────────────────────────────────────────────────

export const TAGS = [
  { tag: 'b', rotulo: 'N', titulo: 'Negrito' },
  { tag: 'i', rotulo: 'I', titulo: 'Itálico' },
  { tag: 'u', rotulo: 'S', titulo: 'Sublinhado' },
];

/**
 * Aplica ou remove a tag na seleção.
 *
 * @param {string} texto  o conteúdo inteiro do campo
 * @param {number} inicio começo da seleção
 * @param {number} fim    fim da seleção (igual ao início = sem seleção)
 * @param {string} tag    'b' | 'i' | 'u'
 * @returns {{ texto: string, inicio: number, fim: number }} texto novo e onde
 *          deixar a seleção depois
 */
export function alternarTag(texto, inicio, fim, tag) {
  const t = String(texto || '');
  const a = Math.max(0, Math.min(inicio ?? 0, t.length));
  const b = Math.max(a, Math.min(fim ?? a, t.length));

  const abre = `<${tag}>`;
  const fecha = `</${tag}>`;
  const selecao = t.slice(a, b);

  // 1) A própria seleção já é "<b>algo</b>": tira as tags de dentro dela.
  if (selecao.startsWith(abre) && selecao.endsWith(fecha) && selecao.length >= abre.length + fecha.length) {
    const miolo = selecao.slice(abre.length, selecao.length - fecha.length);
    return {
      texto: t.slice(0, a) + miolo + t.slice(b),
      inicio: a,
      fim: a + miolo.length,
    };
  }

  // 2) A seleção está ENVOLVIDA pelas tags, que ficaram de fora dela.
  const antes = t.slice(0, a);
  const depois = t.slice(b);
  if (antes.endsWith(abre) && depois.startsWith(fecha)) {
    return {
      texto: antes.slice(0, antes.length - abre.length) + selecao + depois.slice(fecha.length),
      inicio: a - abre.length,
      fim: b - abre.length,
    };
  }

  // 3) Sem seleção: insere o par e deixa o cursor no meio, para começar a
  //    escrever já formatado.
  if (a === b) {
    return {
      texto: `${antes}${abre}${fecha}${depois}`,
      inicio: a + abre.length,
      fim: a + abre.length,
    };
  }

  // 4) Envolve a seleção.
  return {
    texto: `${antes}${abre}${selecao}${fecha}${depois}`,
    inicio: a + abre.length,
    fim: b + abre.length,
  };
}
